<script setup>
import {
    MapPinIcon,
    UserIcon,
    CurrencyDollarIcon,
    PhoneIcon,
    XMarkIcon,
} from '@heroicons/vue/24/outline'

import ImageCarousel from '@/Components/ImageCarousel.vue';
import TabsImages from '@/Components/TabsImages.vue';

import PrimaryButton from "@/Components/PrimaryButton.vue";
import SecondaryButton from "@/Components/SecondaryButton.vue";

const props = defineProps({
    tails: Object,
    singleMode: false,
    processing:false
})

const emit = defineEmits(['show','request']);

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
});

const formatPrice = (price) =>{
    return formatter.format(price);
}

const humanType = (tail) => {
    let type = 'Single';
    if(parseInt(tail.NumberOfEngines) === 2){
        type = 'Twin'
    }
    return type+' Engine '+tail.EngineType;
}

const showSingle = (tail) => {
    emit('show',{tail: tail});
}

const wantsAccess = (tail) => {
    emit('request',{tail: tail});
}

</script>
<template>
    <article v-for="tail in tails" :key="tail.id" class=" flex-col items-start justify-between">
        <div class="relative w-full" v-if="tail.ListingPhotos[0] && !singleMode" @click.prevent="showSingle(tail)" >
            <img :src="tail.ListingPhotos[0].LiveLink" alt="" class="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]" />
            <div class="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
        </div>
        <TabsImages class="lg:w-full w-5/6" v-if="tail.ListingPhotos.length && singleMode" :images="tail.ListingPhotos"></TabsImages>
        <!--<ImageCarousel class="lg:w-full w-5/6" v-if="tail.ListingPhotos.length && singleMode" :images="tail.ListingPhotos" :itemsShow="1"></ImageCarousel>-->
        <div class="max-w-xl">
            <div class="mt-8 flex items-center gap-x-4 text-xs">
                <p class="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100">{{humanType(tail)}}</p>
            </div>
            <div class="group relative">
                <h3 class="mt-3 mb-2 text-lg font-semibold leading-6 text-gray-900 group-hover:text-blue-600 text-logix-light-blue">
                    <span class="absolute inset-0" />
                    {{tail.FullName}}
                </h3>
                <p class="flex"><CurrencyDollarIcon class="h-5 mr-2"/> <span class="text-green-500 font-semibold">{{(tail.ListingInfo.price === 0 || tail.ListingInfo.price === '0' || !tail.ListingInfo.price) ? 'Call' : formatPrice(tail.ListingInfo.price)}}</span></p>
                <p class="flex" v-if="tail.ListingInfo && tail.ListingInfo.location"><MapPinIcon class="h-5 mr-2"/>{{tail.ListingInfo.location}}</p>
                <h5 class="flex" v-if="tail.ListingInfo && tail.ListingInfo.name"><UserIcon class="h-5 mr-2"/>{{tail.ListingInfo.name}}</h5>
                <h5 class="flex" v-if="tail.ListingInfo && tail.ListingInfo.phone"><PhoneIcon class="h-5 mr-2"/>{{tail.ListingInfo.phone}}</h5>
                <p :class="['mt-5  text-sm leading-6 text-gray-600',singleMode ? '' : 'line-clamp-2 break-all']">{{ tail.ListingInfo.desc }}</p>
                <p v-if="singleMode" class="mt-3 text-logix-light-blue">Ready to do more in-depth research?</p>
            </div>
            <div class="relative mt-8 flex items-center gap-x-4" v-if="!singleMode">
                <SecondaryButton @click="showSingle(tail)">
                    See More
                </SecondaryButton>
            </div>
            <div class="relative mt-8 flex items-center gap-x-4" v-else>
                <PrimaryButton @click="wantsAccess(tail)" :class="{ 'opacity-25': processing }" :disabled="processing">
                    Request Records Access
                </PrimaryButton>
            </div>

            <!--<div class="relative mt-2 flex items-center gap-x-4">
                <input ref="copylinkref" v-model="sharingLink" type="text"
                       class="hidden"
                />
                <SecondaryButton @click="copyLink" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Copy Share Link
                </SecondaryButton>
            </div>-->
        </div>
    </article>
</template>
